<script>
import { apiSecond } from '@/boot/axios'

export default {
	name: 'ProjectPowerUser',
	props: {
		userId: Number,
	},
	data() {
		return {
			headers: [
				{ text: this.$t('headers.zpm_nikad'), value: 'zpm_nikad', sortable: false },
				{ text: this.$t('headers.status'), value: 'status', sortable: false },
				{ text: this.$t('headers.start_date'), value: 'start_date', sortable: false },
				{ text: this.$t('headers.end_date'), value: 'end_date', sortable: false },
				{ text: this.$t('headers.zpm_capacity'), value: 'total_capacity', sortable: false },
				{ text: this.$t('headers.remainder'), value: 'total_remainder', sortable: false },
				{ text: '', value: 'data-table-expand' },
			],
			list: [],
			totals: 0,
			expanded: [],
			errorMessage: {
				status: null,
				text: null,
			},
			options: {
				page: Number(this.$route?.query?.page || 1),
				itemsPerPage: Number(this.$route?.query?.per_page || 10),
			},
			isUpdate: true,
		}
	},
	computed: {
		query() {
			return this.$route.query
		},
	},
	watch: {
		query: {
			handler() {
				this.apiGetUserZpm()
			},
			immediate: true,
		},
		userId() {
			this.apiGetUserZpm()
		},
		options: {
			handler(newOptions) {
				if (
					this.$route.query.page != newOptions.page ||
					this.$route.query.per_page != newOptions.itemsPerPage
				) {
					this.$router.replace({
						query: {
							...this.$route.query,
							page: newOptions.page,
							per_page: newOptions.itemsPerPage,
							filterTime: new Date().getTime(),
						},
					})
				}
			},
			deep: true,
		},
		'$route.query.page'(newPage) {
			if (newPage && this.options.page !== Number(newPage)) {
				this.options.page = Number(newPage)
			}
		},
		'$route.query.per_page'(newPerPage) {
			if (newPerPage && this.options.itemsPerPage !== Number(newPerPage)) {
				this.options.itemsPerPage = Number(newPerPage)
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	methods: {
		onOptionsUpdate(newOptions) {
			this.options.page = newOptions.page
			this.options.itemsPerPage = newOptions.itemsPerPage
		},
		statusLabel(status) {
			if (!status) return '-'
			const key = 'zpm.status_' + status
			return this.$te(key) ? this.$t(key) : status
		},
		formatDate(date) {
			if (!date) return '-'
			const parts = String(date).slice(0, 10).split('-')
			if (parts.length !== 3) return date
			return `${parts[2]}.${parts[1]}.${parts[0]}`
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_message
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.text = error.response.data.error_message
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		async apiGetUserZpm() {
			try {
				this.isUpdate = true
				const params = {
					page: this.$route?.query?.page || 1,
					per_page: this.$route?.query?.per_page || 10,
				}
				if (this.userId) params.user_id = this.userId

				const response = await apiSecond.get('v1/zpm/user-data', { params })

				// user-data возвращает { success, data: { data: [], total, ... } }
				const paginator = response?.data?.data
				if (paginator) {
					this.list = paginator.data || []
					this.totals = paginator.total || 0
				}
			} catch (error) {
				this.catchError(error)
			} finally {
				this.isUpdate = false
			}
		},
	},
}
</script>

<template>
	<div class="table__block--content user-profile__block--content">
		<div class="user-profile__block--update">
			<button class="user-profile--update" :disabled="isUpdate" @click="apiGetUserZpm">
				<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
				{{ $t('commands.update') }}
			</button>
		</div>

		<v-data-table
			:headers="headers"
			:items="list"
			:loading="isUpdate"
			:loading-text="$t('button.loading')"
			:no-data-text="$t('system_message.no_data')"
			:no-results-text="$t('system_message.search')"
			item-key="id"
			:expanded.sync="expanded"
			show-expand
			disable-sort
			:options.sync="options"
			:server-items-length="totals"
			:footer-props="{
				'items-per-page-options': [5, 10, 20, 30, 40, 50],
			}"
			@update:options="onOptionsUpdate"
		>
			<template slot="item.status" slot-scope="{ item }">
				{{ statusLabel(item.status) }}
			</template>
			<template slot="item.start_date" slot-scope="{ item }">
				{{ formatDate(item.start_date) }}
			</template>
			<template slot="item.end_date" slot-scope="{ item }">
				{{ formatDate(item.end_date) }}
			</template>
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length" class="py-3">
					<table class="zpm-fishes">
						<thead>
							<tr>
								<th>{{ $t('headers.fish') }}</th>
								<th>{{ $t('headers.zpm_capacity') }}</th>
								<th>{{ $t('headers.remainder') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="fish in item.fishes" :key="fish.id">
								<td>{{ fish.fish_name || '-' }}</td>
								<td>{{ fish.design_capacity }}</td>
								<td>{{ fish.remainder }}</td>
							</tr>
							<tr v-if="!item.fishes || !item.fishes.length">
								<td colspan="3">—</td>
							</tr>
						</tbody>
					</table>
				</td>
			</template>
			<v-alert slot="no-results" :value="true" color="error">
				{{ $t('system_message.search') }}
			</v-alert>
		</v-data-table>
	</div>
</template>

<style scoped>
.zpm-fishes {
	width: 100%;
	border-collapse: collapse;
}
.zpm-fishes th,
.zpm-fishes td {
	padding: 6px 12px;
	text-align: left;
	border-bottom: 1px solid #eef2f7;
	font-size: 13px;
}
.zpm-fishes th {
	color: #708295;
	font-weight: 600;
}
</style>
